'use strict';

/** @type {import('.')} */
module.exports = Error;



//////////////////
// WEBPACK FOOTER
// ../es-errors/index.js
// module id = 683
// module chunks = 0